module.exports = __webpack_public_path__ + "img/Guidograndi_rose.d9dd9548.jpg";